<template>
    <div>
        <div
            class="text-right"
        >
            <b-button
                class="mb-2"
                variant="primary"
                @click="openAddComment"
            >
                Add comment
            </b-button>
        </div>
        <b-table
            striped
            hover 
            :items="notes"
            :fields="notecolumns"
        >
            <template v-slot:cell(comment)="row">
                <a @click="row.toggleDetails">
                    <span style="text-overflow: ellipsis !important;">
                        {{ row.item.comment }}
                    </span>
                </a>
            </template>
            <template #row-details="row">
                <b-card>
                <b-row class="mb-2">
                    <b-col sm="2" class="text-left"><b>Comment:</b></b-col>
                    <b-col sm="10">{{ row.item.comment }}</b-col>
                </b-row>
                </b-card>
            </template>
        </b-table>
        <b-modal
            id="addCommentModal"
            title="Add comment"
            v-model="showAddCommentModal"
            @ok="saveAddComment"
            @close="closeAddComment"
        >
            <b-form-textarea
                v-model="newComment"
                placeholder="Enter comment"
            />
        </b-modal>
    </div>
</template>
<script>
export default {
  name: 'ExamNotes',
  props: {
    examanswerId: {
        type: [String, Number],
        default: ''
    },
  },
  async created() {
    await this.notes_get();
  },
  data() {
    return {
        notes: [],
        notecolumns: [
            { key: 'id', label: 'ID', thClass: 'd-none', tdClass: 'd-none' },
            { key: 'comment_date', label: 'Date' },
            { key: 'comment_from_user_id', label: 'From' },
            { key: 'comment', label: 'Comment', thClass: 'col-8',tdClass:'col-8' },
        ],
        showAddCommentModal: false,
        newComment: '',
        user_id: this.$store.state.user_id,
    }
  },
  methods: {
    saveAddComment() {
        this.$store.dispatch('record_post', {
            table_name: 'g_elearning_consultant_exam_answer_notes',
            record: {
                examanswer_id: this.examanswerId,
                examanswer_comment: this.newComment,
                comment_date: null,
                comment_from_user_id: this.$store.state.user_id,
            }
        }).then(() => {
            this.closeAddComment();
            this.notes_get();
        });
    },
    openAddComment() {
        this.newComment = '';
        this.showAddCommentModal = true;
    },
    closeAddComment() {
        this.newComment = '';
        this.showAddCommentModal = false;
    },
    async notes_get() {
        const filter = {
            examanswer_id: {
                value: this.examanswerId,
                operator: '='
            }
        }
        let notes = await this.$store.dispatch('records_readlist', {
            table_name: 'g_elearning_consultant_exam_answer_notes',
            filter,
        }).then(r => r.data.result);
        notes.sort((a, b) => b.id - a.id);
        this.notes = [];
        for (let note of notes) {
            await this.$store.dispatch('record_read', {
                table_name: 'g_elearning_consultant_exam_answer_notes',
                id: note.id
            }).then(r => {
                note.comment = r.data.examanswer_comment.trim();
                this.$store.dispatch('record_read', {
                    table_name: 'i_user',
                    id: note._comment_from_user_id
                }).then(r => {
                    note.comment_from_user_id = `${r.data.first_name} ${r.data.family_name}`;
                });
            });
            if (note.comment !== '') {
                this.notes.push({
                    id: note.id,
                    comment_date: note.comment_date,
                    comment_from_user_id: note.comment_from_user_id,
                    comment: note.comment,
                });
            }
        }
    }
  }
}
</script>
<style>
</style>